import React from "react";
import { marked } from "marked";
import { useSelector } from "react-redux";

const Previewer = () => {

    const string = useSelector((state) => state.newText.value)

  marked.setOptions({gfm: true, breaks: true});
  
  return (
    <div className="container mt-4" style={{ maxWidth: "800px" }}>
      <h4>Previewer</h4>
      <div
        dangerouslySetInnerHTML={{ __html: marked.parse(string.text) }}
        className="border p-3 rounded" id="preview"
      ></div>
    </div>
  );
};

export default Previewer;
